export const PUBLIC_ROUTES = [
  {
    key: 'home',
    to: '/',
    navLabel: 'Home',
    title: 'PVA Bazaar',
    description: 'Pure life knowledge marketplace, archive, and public bridge for trade, education, and culture.',
    group: 'core',
    badge: 'Start',
    navPlacement: 'primary',
    access: 'public',
  },
  {
    key: 'marketplace',
    to: '/marketplace',
    navLabel: 'Marketplace',
    title: 'Marketplace',
    description: 'Browse goods, sourcing opportunities, educational kits, specimens, and commerce surfaces for real trade and daily use.',
    group: 'core',
    badge: 'Commerce',
    navPlacement: 'primary',
    access: 'public',
  },
  {
    key: 'archive',
    to: '/archive',
    navLabel: 'Archive',
    title: 'Archive Library',
    description: 'Read the living archive, pure life knowledge, and long-form cultural context.',
    group: 'core',
    badge: 'Foundation',
    navPlacement: 'primary',
    access: 'public',
  },
  {
    key: 'writings',
    to: '/writings',
    navLabel: 'Writings',
    title: 'Writings',
    description: 'A public reading path for essays, notes, and long-form archive writing.',
    group: 'core',
    badge: 'Library',
    navPlacement: 'primary',
    access: 'public',
  },
  {
    key: 'partnerships',
    to: '/partnerships',
    navLabel: 'Partnerships',
    title: 'Partnerships',
    description: 'Supplier, institutional, and collaboration pathways for schools, museums, labs, and organizations.',
    group: 'core',
    badge: 'Partner',
    navPlacement: 'primary',
    access: 'public',
  },
  {
    key: 'partners',
    to: '/partners',
    navLabel: 'Partner Program',
    title: 'Partner Program',
    description: 'Join the maker and partner network: craft, sourcing, education, and institutional collaboration.',
    group: 'support',
    badge: 'Partner',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'referral',
    to: '/referral',
    navLabel: 'Referral Rewards',
    title: 'Referral Rewards',
    description: 'Get your own referral code, share it, and earn a 10% kickback on every attributed sale.',
    group: 'support',
    badge: 'Earn',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'about',
    to: '/about',
    navLabel: 'About',
    title: 'About',
    description: 'How PVA Bazaar connects pure life knowledge, trade, provenance, education, and long memory.',
    group: 'support',
    badge: 'About',
    navPlacement: 'primary',
    access: 'public',
  },
  {
    key: 'contact',
    to: '/contact',
    navLabel: 'Contact',
    title: 'Contact',
    description: 'General contact, supplier inquiries, partnerships, and public support.',
    group: 'support',
    badge: 'Contact',
    navPlacement: 'primary',
    access: 'public',
  },
  {
    key: 'get-started',
    to: '/get-started',
    navLabel: 'Get Started',
    title: 'Join PVA Bazaar',
    description: 'Create an account and choose your role — buyer, supplier, artisan, researcher, or contributor.',
    group: 'support',
    badge: 'Register',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'books',
    to: '/books',
    navLabel: 'Books',
    title: 'Books',
    description: 'Books, publishing, and long-form works that explain the labor vision, blueprint, and civic memory behind PVA Bazaar.',
    group: 'core',
    badge: 'Books',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'books-published',
    to: '/books/published',
    navLabel: 'Published Books',
    title: 'Published Books',
    description: 'Browse the public book shelf, read published works online, and download PDF or EPUB editions.',
    group: 'core',
    badge: 'Books',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'institutions',
    to: '/institutions',
    navLabel: 'Institutions',
    title: 'Institution Partnerships',
    description: 'Universities, schools, museums, governments, labs, libraries, NGOs, training centers, and TVETs.',
    group: 'atlas',
    badge: 'Atlas',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'category-agriculture',
    to: '/marketplace/civilization/agriculture',
    navLabel: 'Agriculture',
    title: 'Agriculture',
    description: 'Coffee, tea, spices, herbs, seeds, and medicinal plants connected to land and learning.',
    group: 'atlas',
    badge: 'Atlas',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'category-geology',
    to: '/marketplace/civilization/geology',
    navLabel: 'Geology',
    title: 'Geology',
    description: 'Minerals, gemstones, fossils, meteorites, and mining knowledge.',
    group: 'atlas',
    badge: 'Atlas',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'category-materials',
    to: '/marketplace/civilization/materials',
    navLabel: 'Materials',
    title: 'Materials',
    description: 'Wood, stone, metals, fibers, leather, dyes, pigments, and chemicals.',
    group: 'atlas',
    badge: 'Atlas',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'category-education',
    to: '/marketplace/civilization/education',
    navLabel: 'Education',
    title: 'Education',
    description: 'Educational kits, curricula, laboratory supplies, and museum replicas.',
    group: 'atlas',
    badge: 'Atlas',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'category-craft',
    to: '/marketplace/civilization/craft',
    navLabel: 'Craft',
    title: 'Craft',
    description: 'Textiles, ceramics, glass, woodworking, and artisan goods.',
    group: 'atlas',
    badge: 'Atlas',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'category-trade',
    to: '/marketplace/civilization/trade',
    navLabel: 'Trade',
    title: 'Trade',
    description: 'Import/export, shipping, sourcing, fulfillment, and partnership logistics.',
    group: 'atlas',
    badge: 'Atlas',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'showroom',
    to: '/showroom',
    navLabel: 'Showroom',
    title: 'Showroom',
    description: 'Curated presentation pages for featured products, makers, collections, and institutional showcases.',
    group: 'core',
    badge: 'Display',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'governance',
    to: '/proposals',
    navLabel: 'Governance',
    title: 'Governance',
    description: 'The People\'s Proposal Board with endorsement and decision lifecycle.',
    group: 'core',
    badge: 'Civic',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'conference',
    to: '/conference',
    navLabel: 'Popular Conference',
    title: 'Popular Conference',
    description: 'Popular Conference session workflow and civic execution context.',
    group: 'support',
    badge: 'Civic',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'forum',
    to: '/forum',
    navLabel: 'Forum',
    title: 'Forum',
    description: 'Main civic forum with proposal feed and voting.',
    group: 'support',
    badge: 'Featured',
    featured: true,
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'governance-conference',
    to: '/governance/conference',
    navLabel: 'Governance Conference',
    title: 'Governance Conference',
    description: 'Governance agenda and conference session view.',
    group: 'support',
    navPlacement: 'secondary',
    access: 'citizen',
  },
  {
    key: 'governance-treasury',
    to: '/governance/treasury',
    navLabel: 'Governance Treasury',
    title: 'Governance Treasury',
    description: 'Treasury balances and transparency ledger.',
    group: 'support',
    navPlacement: 'secondary',
    access: 'citizen',
  },
  {
    key: 'recovery',
    to: '/recovery',
    navLabel: 'Recovery',
    title: 'Recovery',
    description: 'Recovery, continuity, and install tools for keeping the site close across devices and returns.',
    group: 'support',
    badge: 'Continuity',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'provenance',
    to: '/provenance',
    navLabel: 'Provenance',
    title: 'Provenance',
    description: 'Product origins, supply-chain trust, verification, and ethical sourcing context.',
    group: 'support',
    badge: 'Trust',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'portfolio',
    to: '/portfolio',
    navLabel: 'Portfolio',
    title: 'Portfolio',
    description: 'Selected projects, partnerships, and public work samples.',
    group: 'support',
    badge: 'Projects',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'identity-center',
    to: '/identity-center',
    navLabel: 'Citizen Passport',
    title: 'Citizen Passport',
    description: 'Identity, wallet, governance, and economy records for each citizen node.',
    group: 'support',
    navPlacement: 'secondary',
    access: 'citizen',
  },
  {
    key: 'passport',
    to: '/passport',
    navLabel: 'My Passport',
    title: 'My Passport',
    description: 'Citizen passport profile and wallet identity center.',
    group: 'support',
    navPlacement: 'secondary',
    access: 'citizen',
  },
  {
    key: 'creator',
    to: '/creator',
    navLabel: 'Supplier Portal',
    title: 'Supplier Portal',
    description: 'Start as a supplier, artisan, researcher, or sourcing partner and submit products to the network.',
    group: 'core',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'cart',
    to: '/cart',
    navLabel: 'Cart',
    title: 'Shopping Cart',
    description: 'Review items in your cart and proceed to checkout.',
    group: 'support',
    navPlacement: 'secondary',
    access: 'public',
  },
  {
    key: 'heelkawn',
    to: '/heelkawn',
    navLabel: 'HeelKawn',
    title: 'HeelKawn',
    description: 'HeelKawn Armory hub with profile, customization, social tools, and mobile/PC downloads.',
    group: 'support',
    navPlacement: 'secondary',
    access: 'public',
  },
]

export const HOME_CORE_ROUTES = PUBLIC_ROUTES.filter((route) => route.group === 'core')
export const HOME_SUPPORT_ROUTES = PUBLIC_ROUTES.filter((route) => route.group === 'support')
